module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-1.f37f981b.png";